import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Grid of captioned screenshots. `columns`/`columnsSm` drive the layout through CSS
// custom properties (keeps non-DOM props off the element). Pass `ratio` on an item
// (e.g. '16/10') to crop a wide screenshot to a uniform tile.
const StyledGallery = styled.div`
  display: grid;
  grid-template-columns: repeat(var(--cols), minmax(0, 1fr));
  gap: 18px;
  margin-top: 18px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(var(--cols-sm), minmax(0, 1fr));
    gap: 14px;
  }

  figure {
    margin: 0;
  }

  img {
    display: block;
    width: 100%;
    height: auto;
    background: var(--light-navy);
    border: 1px solid var(--lightest-navy);
    border-radius: var(--border-radius);
  }

  .crop {
    overflow: hidden;
    border: 1px solid var(--lightest-navy);
    border-radius: var(--border-radius);

    img {
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 0;
      object-fit: cover;
      object-position: top center;
    }
  }

  figcaption {
    margin-top: 12px;
    color: var(--slate);
    font-size: var(--fz-sm);
    line-height: 1.5;

    strong,
    b {
      color: var(--lightest-slate);
      font-weight: 600;
    }
  }
`;

export const Gallery = ({ items, columns = 2, columnsSm = 1 }) => (
  <StyledGallery style={{ '--cols': columns, '--cols-sm': columnsSm }}>
    {items.map((it, i) => (
      <figure key={i}>
        {it.ratio ? (
          <div className="crop" style={{ aspectRatio: it.ratio }}>
            <img src={it.src} alt={it.alt} />
          </div>
        ) : (
          <img src={it.src} alt={it.alt} />
        )}
        {it.caption && <figcaption>{it.caption}</figcaption>}
      </figure>
    ))}
  </StyledGallery>
);
Gallery.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string.isRequired,
      alt: PropTypes.string.isRequired,
      caption: PropTypes.node,
      ratio: PropTypes.string,
    }),
  ).isRequired,
  columns: PropTypes.number,
  columnsSm: PropTypes.number,
};
